document.addEventListener('DOMContentLoaded', function () {
  const txtElements = document.querySelectorAll('.side-menu');
  const menuOverlay = document.querySelector('.side-menu-overlay');

  txtElements.forEach(menu => {    
    new SideMenu(menu, menuOverlay);
  });
});

class SideMenu {
  constructor(txtElement, overlayElement) {
    this.menu = txtElement;
    this.overlay = overlayElement;    
    this.buttonClose = txtElement.querySelector('.btn-close');
    this.modalName = txtElement.getAttribute('data-modal-name')        
    
    this.side = txtElement.classList.contains('left') ? 'left' : 'right';  
    this.duration = parseFloat(txtElement.getAttribute('data-duration')) || 1;
    this.menu.style.transitionDuration = `${this.duration}s`;
   
    if (this.modalName) {  
      this.callingBtns = document.querySelectorAll( `.${this.modalName}` )        
      this.events() 
    }
  }

  toggleMenu() {
    const isHidden = this.menu.classList.contains('moveout');

    if (isHidden) {
      this.openMenu();  
    } else {
      this.closeAllMenus();
    }
  }

  openMenu(){
    this.menu.classList.remove('moveout');
    this.overlay.classList.remove('p-hidden');
    document.body.classList.add('p-overflow-hidden');      
  }

  closeAllMenus() {
    document.querySelectorAll('.side-menu').forEach(menu => {    
      menu.classList.add('moveout');
    });
    this.overlay.classList.add('p-hidden');
    document.body.classList.remove('p-overflow-hidden');
  }

  events() {
    if (this.callingBtns) {  
      this.callingBtns.forEach(item => {
        item.style.cursor = 'pointer';
        item.addEventListener('click', e => {
          e.preventDefault();          
          this.toggleMenu();
        });
      });
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', e => {
        e.preventDefault();
        this.toggleMenu();
      });
    }

    this.overlay.addEventListener('click', () => this.closeAllMenus());
    window.addEventListener('resize', () => this.closeAllMenus());
  }
}